import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Button from '../common/Button';
import Modal from '../common/Modal';
import ProjectCreate from '../projects/create/';
import ProjectItem from '../projects/Item';
import ListProjects from '../projects/List';
import { updateProjects } from './duck';
import JoinProjectsToUser from '../user/join-projects/';

class Projects extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      mode: 'JOIN',
    };
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  handleProjectAddSuccess = (user) => {
    this.props.updateProjects(user.projects);
    this.closeModal();
  };

  renderProjectItems = (projects) => {
    const { status } = this.props;

    // On user profile only, force displaying projects as inactive,
    // if the current user doesn't work actively on this project.
    const forceInactive = status === 'INACTIVE';

    return projects.map(({ project }) => (
      <div
        key={project._id}
        className="o-layout__item u-1/2@maxi-stelyo u-1/1 u-margin-bottom"
      >
        <ProjectItem forceInactive={forceInactive} project={project} />
      </div>
    ));
  };

  render() {
    const {
      projects,
      title,
      titlePrefixColor,
      titlePrefix,
      titleColor,
      type,
      isLoggedInUser,
      enableCreateNew,
      t,
      forceRendering,
    } = this.props;
    const { mode } = this.state;

    // Skip rendering, except this user is the currently logged one.
    // If so -> display the empty list anyways,
    // becase we want the call-to-action - add new project - to appear!
    const shouldSkipRendering = !projects.length && !isLoggedInUser;
    if (shouldSkipRendering) {
      return null;
    }

    const enableCreate = isLoggedInUser && enableCreateNew;

    return (
      <React.Fragment>
        <div className="u-margin-bottom-huge">
          <ListProjects
            projects={projects}
            renderItems={this.renderProjectItems}
            title={title}
            titleColor={titleColor}
            titlePrefixColor={titlePrefixColor}
            titlePrefix={titlePrefix}
            forceRendering={isLoggedInUser && forceRendering}
          />
          {enableCreate && (
            <Button styleType="outline" onClick={this.openModal}>
              {t('user.joinOrAddProjectBtn')}
            </Button>
          )}
        </div>
        {enableCreate && (
          <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            title={t('user.addOrJoinProjectTitle')}
          >
            <div className="u-display-flex u-align-items-center u-margin-bottom-tiny">
              <input
                component="input"
                type="radio"
                name="status"
                id="JOIN"
                className="c-radio"
                value="JOIN"
                onChange={() => this.setState({ mode: 'JOIN' })}
                checked={mode === 'JOIN'}
              />
              <label className="u-cursor-pointer" htmlFor="JOIN">
                {t('user.joinProjectLabel')}
              </label>
            </div>
            {mode === 'JOIN' && (
              <JoinProjectsToUser
                showJoinedProjectsList={false}
                projectsType={['DEFAULT', 'SIDE']}
                onSuccess={this.closeModal}
              />
            )}

            <div className="u-display-flex u-align-items-center u-margin-bottom-large">
              <input
                component="input"
                type="radio"
                name="status"
                id="ADD"
                className="c-radio"
                value="ADD"
                onChange={() => this.setState({ mode: 'ADD' })}
                checked={mode === 'ADD'}
              />
              <label className="u-cursor-pointer" htmlFor="ADD">
                {t('user.addProjectLabel')}
              </label>
            </div>
            {mode === 'ADD' && (
              <ProjectCreate
                type={type}
                onSuccess={this.handleProjectAddSuccess}
              />
            )}
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

Projects.defaultProps = {
  enableCreateNew: true,
  forceRendering: true,
};

const mapStateToProps = ({ user: currentUser }, { type, status, user }) => {
  const isLoggedInUser = user._id === currentUser.data._id;
  // If currently logged in user, ref the projects from the redux store,
  // because otherwise they don't get updated, when changes are made.
  const projects = isLoggedInUser ? currentUser.data.projects : user.projects;

  return {
    projects: projects.filter(({ project, status: s }) => {
      const isCorrectType =
        typeof type === 'string'
          ? project.type === type
          : type.includes(project.type);

      return isCorrectType && s === status;
    }),
    isLoggedInUser,
  };
};

const mapDispatchToProps = { updateProjects };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(Projects));



// WEBPACK FOOTER //
// ./src/user/Projects.js